import React, { Fragment, useEffect, useState } from 'react';
import {
  Button,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExternalLinkAlt,
} from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import BookingEngineStats from './BookingEngineStats';
const Number = ({
  bookingCsvData,
  history,
  numberdata,
  totalTicketStats,
  numbertimedata,
  bookingEngineStats,
  fromDate,
  toDate,
  isBookingEngineConnect,
  bookingEngineSearchData,
  messengerAvatar, propertyData,
  contactStatsData,
  isBusinessOperator,
  isUtilityProvider,
  propertyId
}) => {
  const [bookingEngine, setBookingEngine] = useState(0);
  const [estimatedTimeSaving, setEstimatedTimeSaving] = useState("");
  useEffect(() => {
    if (bookingEngineStats !== undefined) {
      let data = bookingEngineStats.filter((i) => i.button === "Book Now" || i.button === "Check Availability & Rates").reduce(function (prev, current) {
        return prev + +current.visits
      }, 0);
      setBookingEngine(data)
    }
    if (numberdata !== undefined && numberdata !== null && propertyData) {
      var value = calculateEstimate(numberdata.filter(l => l.type === "estimatedTimeSaving")[0].value);
      setEstimatedTimeSaving(value);
    }
  }, [propertyData, numberdata]);

  const getLabel = (lab) => {
    switch (lab.toLowerCase()) {
      case "webchattime":
        return "dashboards.number-webchattime";
      case "totalconversation":
        return "dashboards.number-totalconversation";
      case "websiteconversation":
        return "dashboards.number-websiteconversation";
      case "facebookconversation":
        return "dashboards.number-facebookconversation";
      case "instagramconversation":
        return "dashboards.number-instagramconversation";
      case "estimatedtimesaving":
        return "dashboards.number-estimatedtimesaving";
      case "googlemapsconversation":
        return "dashboards.number-googlemapsconversation";
      case "whatsappconversation":
        return "dashboards.number-whatsappconversation"
      case "agentconversation":
        return "dashboards.number-agentconversation";
      case "amenityqueries":
        return "dashboards.number-amenityqueries";
      case "bookingenquiries":
        return "dashboards.number-bookingenquiries";
      case "eventenquiries":
        return "dashboards.number-eventenquiries";
      case "longstayenquiries":
        return "dashboards.number-longstayenquiries";
      case "totaltickets":
        return "dashboards.number-totaltickets";
      case "groupbookingenquiries":
        return "dashboards.number-groupbookingenquiries";
      case "returncustomers":
        return "dashboards.number-returncustomer";
      case "websiteredirects":
        return "dashboards.number-redirects";
      case "bookingengine":
        return "dashboards.number-bookingengineleads"
    }
    return lab
  };
  const getLabelIcon = (lab) => {
    switch (lab.toLowerCase()) {
      case "webchattime":
        return "iconsminds-clock";
      case "totalconversation":
        return "iconsminds-speach-bubbles";
      case "websiteconversation":
        return "iconsminds-speach-bubbles";
      case "facebookconversation":
        return "iconsminds-facebook";
      case "estimatedtimesaving":
        return "iconsminds-clock";
      case "googlemapsconversation":
        return "simple-icon-social-google";
      case "agentconversation":
        return "iconsminds-speach-bubbles";
      case "amenityqueries":
        return "iconsminds-speach-bubbles";
      case "bookingenquiries":
        return "iconsminds-speach-bubbles";
      case "eventenquiries":
        return "iconsminds-check";
      case "longstayenquiries":
        return "iconsminds-check";
      case "totaltickets":
        return "iconsminds-check";
      case "groupbookingenquiries":
        return "iconsminds-check";
      case "returncustomers":
        return "iconsminds-user";
      case "websiteredirects":
        return "iconsminds-turn-up-2";
      case "avatarclick":
        return "iconsminds-finger-print";
    }
    return lab
  };
  const handleConnected = (value) => {
    history.push({
      pathname: '/app/pages/integration/channels',
      state: { tagName: value },
    });
  };
  const calculateDay = (startDate, endDate) => {
    var start = moment(startDate).format("YYYY-MM-DD");
    var end = moment(endDate).format("YYYY-MM-DD");
    var date1 = new Date(start);
    var date2 = new Date(end);
    var time_difference = date2.getTime() - date1.getTime();
    return time_difference / (1000 * 60 * 60 * 24);
  }
  const handleTicketURL = (value, type) => {
    let days = calculateDay(fromDate, toDate);
    if (type === "groupbookingenquiries" || type === "eventenquiries" || type === "longstayenquiries" || type === "totalTickets") {
      let tag = type === "groupbookingenquiries" ? "GroupBooking" : type === "eventenquiries" ? "Conference" : type === "longstayenquiries" ? "LongStay" : "-1";
      history.push({
        pathname: '/app/pages/agent-assist',
        state: { tagName: tag, date: days },
      });
    }
  };
  const handleArchiveURL = (value, type) => {
    let days = calculateDay(fromDate, toDate);
    if (type === "amenityQueries" || type === "bookingEnquiries" || type === "eventEnquiries" || type === "Human Chat" || type === "All") {
      history.push({
        pathname: '/app/pages/agent-assist',
        state: { tagName: type, date: days },
      });
    }
    else {
      history.push({
        pathname: '/app/pages/agent-assist',
        state: { channelName: type, date: days },
      });
    }
  };
  const renderBookingEngine = () => {
    if (isBusinessOperator || isUtilityProvider) return null;

    return (
      <BookingEngineStats
        bookingCsvData={bookingCsvData}
        bookingEngineSearchData={bookingEngineSearchData}
        isBookingEngineConnect={isBookingEngineConnect}
        booknow={bookingEngine}
        fromDate={fromDate}
        toDate={toDate}
        propertyId={propertyId}
      />
    );
  };
  const getConversation = (data) => {
    if (isBusinessOperator === true || isUtilityProvider === true) {
      data = data.filter(x => x.type !== "amenityQueries" && x.type !== "bookingEnquiries")
    }
    return <Fragment>
      {data !== undefined && data.length > 0 && data.map((per, index) =>
        per.type === "websiteConversation" && per.value === null ||
          per.type === "facebookConversation" && per.value === null ||
          per.type === "whatsappConversation" && per.value === null ||
          per.type === "instagramConversation" && per.value === null
          ? (
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
              <div className="card">
                <div className="text-center card-body">
                  {per.type === "whatsappConversation" || per.type === "instagramConversation" ?
                    <i><FontAwesomeIcon
                      icon={per.type === "whatsappConversation" ? faWhatsapp : faInstagram}
                      className="fa ml-1"
                      style={{ fontSize: "46px" }}
                    /></i> :
                    <i className={getLabelIcon(per.type)}></i>
                  }
                  <p className="card-text font-weight-semibold mb-0">
                    <IntlMessages id={getLabel(per.type)} />
                  </p>
                  <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                    <Button
                      size="xs"
                      color="primary"
                      outline
                      style={{ display: 'inline-block' }}
                      onClick={() => handleConnected(per.type)}
                    >
                      <IntlMessages id='dashboards.connect' />
                    </Button></p>
                </div>
              </div>
            </div>
          ) :
          per.type !== "webchattime" && per.type !== "estimatedTimeSaving" &&
            per.type === "websiteConversation" && per.value !== null ||
            per.type === "facebookConversation" && per.value !== null ||
            per.type === "whatsappConversation" && per.value !== null ||
            per.type === "instagramConversation" && per.value !== null ||
            per.type === "bookingEnquiries" ?
            (
              <div className="mb-4 col-sm-4 col-lg-3 col-xl-3"
                style={{ cursor: "pointer" }}
                key={index}
                onClick={() => handleArchiveURL(per.value, per.type)}
              >
                <div className="card">
                  <div className="text-center card-body">
                    {per.type === "whatsappConversation" || per.type === "instagramConversation" ?
                      <i><FontAwesomeIcon
                        icon={per.type === "whatsappConversation" ? faWhatsapp : faInstagram}
                        className="fa ml-1"
                        style={{ fontSize: "46px" }}
                      /></i> :
                      <i className={getLabelIcon(per.type)}></i>
                    }
                    <p className="card-text font-weight-semibold mb-0">
                      <IntlMessages id={getLabel(per.type)} />
                    </p>
                    <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                      {/* {per.value + " Conversations (" + per.percentage + "%)"} */}
                      {per.value} <IntlMessages id="menu.conversations" /> ({per.percentage}%)
                    </p>
                  </div>
                </div>
              </div>
            ) :
            per.type === "agentConversation" ? (
              <div className="mb-4 col-sm-4 col-lg-3 col-xl-3" key={index}
                style={{ cursor: "pointer" }}
                onClick={() => handleArchiveURL(per.value, "Human Chat")}>
                <div className="card">
                  <div className="text-center card-body">
                    <i className={getLabelIcon(per.type)}></i>
                    <p className="card-text font-weight-semibold mb-0">
                      <IntlMessages id={getLabel(per.type)} />
                    </p>
                    <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                      {/* {per.value + " Conversations (" + per.percentage + "%)"}
                       */}
                      {per.value} <IntlMessages id="menu.conversations" /> ({per.percentage}%)
                    </p>
                  </div>
                </div>
              </div>
            ) :
              per.type === "websiteRedirects" && (
                <Fragment>
                  {!isBusinessOperator && !isUtilityProvider &&
                    <Fragment>
                      <div className="mb-4 col-sm-4 col-lg-3 col-xl-3" key={index}>
                        <div className="card">
                          <div className="text-center card-body">
                            <i className="svg-class"><svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                              width="30.000000pt" height="30.000000pt" viewBox="0 0 300.000000 300.000000"
                              preserveAspectRatio="xMidYMid meet">
                              <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                                <path d="M1265 2850 c-431 -89 -789 -405 -923 -817 -42 -128 -56 -222 -55 -378 0 -164 14 -247 63 -397 45 -134 127 -283 198 -361 l26 -27 -170 0 c-189 0 -214 -7 -254 -72 -19 -31 -20 -47 -18 -310 l3 -278 38 -37 37 -38 1278 -3 c1260 -2 1277 -2 1310 18 18 11 41 34 52 52 19 31 20 51 20 298 0 247 -1 267 -20 298 -40 65 -65 72 -254 72 l-170 0 26 28 c79 85 170 259 213 406 38 132 49 216 49 366 -1 244 -64 452 -199 656 -184 276 -476 468 -804 529 -115 21 -330 19 -446 -5z m21 -55 c-22 -16 -46 -20 -46 -7 0 15 13 22 39 22 25 -1 25 -1 7 -15z m184 -280 l0 -295 -260 0 c-143 0 -260 2 -260 4 0 16 60 157 97 229 94 181 216 301 348 343 81 26 75 50 75 -281z m179 264 c111 -49 222 -168 304 -326 37 -72 97 -213 97 -229 0 -2 -117 -4 -260 -4 l-260 0 0 296 0 296 38 -7 c20 -3 57 -15 81 -26z m106 20 c13 -19 -5 -23 -38 -6 l-32 16 32 0 c17 1 35 -4 38 -10z m-550 -41 c-49 -36 -103 -98 -162 -186 -55 -82 -137 -258 -149 -319 l-6 -33 -199 0 -199 0 17 28 c81 129 226 283 339 359 75 51 187 108 284 144 91 34 116 36 75 7z m657 -4 c94 -34 215 -94 291 -146 112 -76 257 -228 331 -345 l26 -43 -199 0 -199 0 -6 33 c-12 61 -94 236 -149 319 -59 88 -113 150 -162 186 -40 28 -21 27 67 -4z m-350 -576 c-9 -9 -15 -9 -24 0 -10 10 -10 15 2 22 9 6 19 5 24 0 7 -7 6 -14 -2 -22z m-646 -35 c-23 -59 -56 -284 -56 -385 l0 -68 -235 0 -234 0 5 53 c13 129 59 308 101 390 l14 27 205 0 c188 0 206 -1 200 -17z m604 -218 l0 -235 -301 0 -302 0 7 103 c7 112 19 196 42 300 l16 67 269 0 269 0 0 -235z m614 163 c27 -125 35 -185 42 -293 l7 -105 -302 0 -301 0 0 235 0 235 269 0 270 0 15 -72z m469 45 c43 -84 91 -271 100 -390 l4 -53 -232 0 -232 0 -6 113 c-6 103 -36 299 -52 340 -7 16 7 17 199 17 l205 0 14 -27z m-1743 -570 c0 -96 31 -311 55 -393 4 -13 -22 -15 -203 -13 l-207 3 -26 62 c-33 82 -66 207 -74 283 -3 33 -8 75 -11 93 l-5 32 236 0 235 0 0 -67z m660 -170 l0 -238 -270 0 -270 0 -14 65 c-20 88 -46 288 -46 356 l0 54 300 0 300 0 0 -237z m660 183 c0 -68 -26 -268 -46 -356 l-14 -65 -270 0 -270 0 0 238 0 237 300 0 300 0 0 -54z m523 -3 c-9 -102 -40 -235 -74 -326 l-34 -88 -207 -2 c-181 -2 -207 0 -203 13 24 82 55 297 55 393 l0 67 234 0 235 0 -6 -57z m-1747 -545 c12 -35 31 -83 43 -107 11 -25 21 -46 21 -48 0 -2 -71 -3 -158 -3 l-158 0 -26 28 c-30 31 -138 181 -138 191 0 3 89 5 197 4 l198 -3 21 -62z m564 -46 l0 -112 -217 2 -218 3 -37 87 c-21 48 -40 98 -43 110 l-6 23 261 0 260 0 0 -113z m580 108 c0 -10 -59 -159 -75 -190 l-16 -30 -214 0 -215 0 0 113 0 112 260 0 c143 0 260 -2 260 -5z m460 -1 c0 -10 -108 -160 -138 -191 l-26 -28 -158 0 c-87 0 -158 2 -158 5 0 3 11 27 24 53 13 26 31 72 41 102 10 30 19 57 20 60 4 7 395 6 395 -1z m274 -305 l26 -27 0 -257 0 -257 -26 -27 -27 -26 -1257 0 -1257 0 -27 26 -26 27 0 257 0 257 26 27 27 26 1257 0 1257 0 27 -26z" />
                                <path d="M460 703 c-48 -25 -76 -81 -61 -126 14 -41 107 -133 143 -142 17 -4 28 -16 33 -32 9 -36 101 -130 140 -143 84 -28 166 61 132 142 -17 40 -106 125 -139 133 -16 4 -29 18 -36 39 -14 37 -112 136 -136 136 -8 0 -20 2 -28 5 -7 3 -29 -3 -48 -12z m115 -103 c27 -27 45 -53 41 -57 -4 -5 -16 2 -27 15 -10 13 -26 22 -36 20 -26 -5 -28 -44 -4 -60 22 -14 28 -28 11 -28 -6 0 -31 21 -55 48 -45 47 -55 78 -33 100 23 23 54 12 103 -38z m89 -92 c15 -25 -32 -73 -63 -63 -27 8 -27 25 0 59 23 29 46 31 63 4z m78 -75 c26 -26 48 -55 48 -64 0 -64 -47 -66 -112 -4 -27 24 -48 49 -48 55 0 17 14 11 28 -11 17 -27 56 -22 60 8 2 14 -4 26 -17 33 -20 10 -29 30 -14 30 4 0 29 -21 55 -47z" />
                                <path d="M1101 613 c-12 -9 -14 -16 -5 -30 11 -17 48 -18 700 -21 379 -1 699 0 712 3 22 5 31 38 13 50 -6 3 -323 6 -707 8 -527 1 -701 -1 -713 -10z" />
                                <path d="M1102 428 c-14 -14 -16 -35 -3 -43 7 -4 783 -8 949 -5 9 0 12 10 10 28 l-3 27 -470 3 c-358 2 -474 -1 -483 -10z" />
                              </g>
                            </svg></i>
                            <p className="card-text font-weight-semibold mb-0">
                              <IntlMessages id={getLabel('bookingengine')} /></p>
                            <p className="lead text-center" style={{ fontSize: "1.2rem" }}>{bookingEngineSearchData?.bookingEngineLeads} <IntlMessages id="dashboards.leads" /></p>
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  }
                  <div className="mb-4 col-sm-4 col-lg-3 col-xl-3" key={index}>
                    <div className="card">
                      <div className="text-center card-body">
                        <i className='color-theme-1'>
                          <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                            width="40" height="40" viewBox="0 0 512.000000 512.000000"
                            preserveAspectRatio="xMidYMid meet">
                            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                              <path fill='currentColor' d="M3295 4946 c-94 -41 -124 -168 -58 -247 51 -60 41 -59 635 -59 l543 0 -1162 -1162 c-1264 -1265 -1186 -1180 -1168 -1275 9 -49 69 -109 118 -118 95 -18 10 -96 1274 1168 l1163 1161 2 -556 c3 -544 3 -557 24 -584 39 -53 71 -69 134 -69 63 0 95 16 134 69 21 27 21 35 21 806 0 771 0 779 -21 806 -11 15 -33 37 -48 48 -27 21 -37 21 -794 23 -622 2 -773 0 -797 -11z" />
                              <path fill='currentColor' d="M521 4304 c-169 -45 -301 -180 -346 -351 -23 -86 -23 -3340 0 -3426 45 -173 178 -307 350 -352 52 -13 260 -15 1715 -15 1805 0 1705 -3 1822 56 116 59 221 197 247 326 8 37 11 364 9 1065 -3 1004 -3 1012 -24 1039 -39 53 -71 69 -134 69 -63 0 -95 -16 -134 -69 -21 -27 -21 -37 -26 -1046 -5 -1009 -5 -1019 -26 -1046 -11 -15 -33 -37 -48 -48 l-27 -21 -1659 0 -1659 0 -27 21 c-15 11 -37 33 -48 48 l-21 27 0 1659 0 1659 21 27 c11 15 33 37 48 48 27 21 37 21 1046 26 1009 5 1019 5 1046 26 53 39 69 71 69 134 0 63 -16 95 -69 134 -27 21 -34 21 -1049 23 -868 2 -1030 0 -1076 -13z" />
                            </g>
                          </svg></i>
                        <p className="card-text font-weight-semibold mb-0">
                          <IntlMessages id={getLabel(per.type)} /></p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}>{per.value} <IntlMessages id="dashboards.clicks" /></p>
                      </div>
                    </div>
                  </div>
                  <div className='mb-4 col-sm-4 col-lg-3 col-xl-3'>
                    <div className='card'>
                      <div className='text-center card-body'>
                        <i className='iconsminds-user' style={{ lineHeight: "51px" }}></i>
                        <p className="card-text font-weight-semibold mb-0 mt-1">New Contacts</p>
                        <p className="lead text-center mb-1" style={{ fontSize: "1.2rem", lineHeight: "1px" }}>
                          {contactStatsData.filter(x => x.name !== "" || x.email !== "" || x.phone !== "").length}<br />
                        </p>
                        <p className="lead text-center mb-1" style={{ fontSize: "14px" }}>
                          ({contactStatsData.filter(k => k.consent === "Yes").length} consented to remarketing)
                        </p>
                      </div>
                    </div>
                  </div>
                  {renderBookingEngine()}
                </Fragment>
              )
      )}
    </Fragment>
  }
  const CalculateHours = (value) => {
    var hours = (value / 60);
    return Math.ceil(hours);
  }
  const numberFormat = (value) =>
    new Intl.NumberFormat().format(value);

  const calculateEstimate = (val) => {
    var result = "";
    var Hours = CalculateHours(parseInt(val));
    if (propertyData !== undefined && propertyData !== null) {
      if (propertyData.isGroupLevel === true) {
        if (propertyData.totalwageRate !== 0) {
          var cal = parseInt(Hours) * parseInt(propertyData.totalwageRate);
          result = propertyData.currency + " " + numberFormat(Math.round(cal)) + "+ ";
        }
        if (propertyData.totalwageRateUSD != 0) {
          var cal = parseInt(Hours) * parseInt(propertyData.totalwageRateUSD);
          if (result === "") {
            result = result + "USD " + numberFormat(Math.round(cal)) + "+";
          } else {
            result = result + " (USD " + numberFormat(Math.round(cal)) + "+)";
          }
        }
      }
      else {
        if (propertyData.totalwageRate !== 0) {
          var cal = parseInt(Hours) * parseInt(propertyData.totalwageRate);
          result = propertyData.currency + " " + numberFormat(Math.round(cal));
        }
      }
    }
    return result === "" ? "" : " (" + result + ")";
  }
  // const NumberTimeDiv = (data) => {
  //   data = data.filter(x => x.type !== "webchattime" && x.type !== "totalConversation");
  //   return <Fragment>
  //     {data !== undefined && data.length > 0 && data.map((per, index) =>
  //       per.type === "webchattime" || per.type === "estimatedTimeSaving" ? (
  //         <Fragment>
  //           {per.type === "webchattime" ?
  //             <Fragment>
  //               {messengerAvatar !== undefined && messengerAvatar !== null && (
  //                 AvatarClickDiv(messengerAvatar)
  //               )}
  //             </Fragment> : ""}
  //         </Fragment>
  //       ) : null
  //     )}
  //   </Fragment>
  // }
  const getTotalTicket = (data) => {
    return <Fragment>
      {data.map((per, index) => (
        <div className="mb-4 col-sm-4 col-lg-3 col-xl-3" key={index}
          style={{ cursor: "pointer" }} onClick={() => handleTicketURL("", per.type)}>
          <div className="card">
            <div className="text-center card-body">
              <i className={getLabelIcon(per.type)}></i>
              <p className="card-text font-weight-semibold mb-0">
                <IntlMessages id={getLabel(per.type)} /></p>
              <p className="lead text-center" style={{ fontSize: "1.2rem" }}
              >{per.value} {per.type === "totalTickets" ?
                <IntlMessages id="dashboards.tickets" /> :
                <IntlMessages id="dashboards.leads" />
                }</p>
            </div>
          </div>
        </div>
      ))}
    </Fragment>
  }
  const AvatarClickDiv = (data) => {
    return <Fragment>
      <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
        <div className="card">
          <div className="text-center card-body">
            <i className={getLabelIcon("avatarclick")}></i>
            <p className="card-text font-weight-semibold mb-0">
              <IntlMessages id="dashboards.number-totalavatarclick" />
            </p>
            <p className="lead text-center" style={{ fontSize: "1.2rem" }}>{data} <IntlMessages id="dashboards.clicks" /></p>
          </div>
        </div>
      </div>
    </Fragment>
  }
  const NewDisplayIntegrationConversations = (data) => {
    return (<Fragment>
      {data !== undefined && data.length > 0 && data.map((per, index) =>
        <Fragment>
          {per.type === "websiteConversation" && per.value === null ||
            per.type === "facebookConversation" && per.value === null ||
            per.type === "whatsappConversation" && per.value === null ||
            per.type === "instagramConversation" && per.value === null ?
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
              <div className="card">
                <div className="text-center card-body">
                  {per.type === "whatsappConversation" || per.type === "instagramConversation" ?
                    <i><FontAwesomeIcon
                      icon={per.type === "whatsappConversation" ? faWhatsapp : faInstagram}
                      className="fa ml-1"
                      style={{ fontSize: "46px" }}
                    /></i> :
                    <i className={getLabelIcon(per.type)}></i>
                  }
                  <p className="card-text font-weight-semibold mb-0">
                    <IntlMessages id={getLabel(per.type)} />
                  </p>
                  <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                    <Button
                      size="xs"
                      color="primary"
                      outline
                      style={{ display: 'inline-block' }}
                      onClick={() => handleConnected(per.type)}
                    >
                      <IntlMessages id='dashboards.connect' />
                    </Button></p>
                </div>
              </div>
            </div> : per.type === "websiteConversation" && per.value !== null ||
              per.type === "facebookConversation" && per.value !== null ||
              per.type === "whatsappConversation" && per.value !== null ||
              per.type === "instagramConversation" && per.value !== null ?
              <div className="mb-4 col-sm-4 col-lg-3 col-xl-3"
                style={{ cursor: "pointer" }}
                key={index}
                onClick={() => handleArchiveURL(per.value, per.type)}
              >
                <div className="card">
                  <div className="text-center card-body">
                    {per.type === "whatsappConversation" || per.type === "instagramConversation" ?
                      <i><FontAwesomeIcon
                        icon={per.type === "whatsappConversation" ? faWhatsapp : faInstagram}
                        className="fa ml-1"
                        style={{ fontSize: "46px" }}
                      /></i> :
                      <i className={getLabelIcon(per.type)}></i>
                    }
                    <p className="card-text font-weight-semibold mb-0">
                      <IntlMessages id={getLabel(per.type)} />
                    </p>
                    <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                      {/* {per.value + " Conversations (" + per.percentage + "%)"} */}
                      {per.value} <IntlMessages id="menu.conversations" /> ({per.percentage}%)
                    </p>
                  </div>
                </div>
              </div> : ""}
          {per.type === "agentConversation" && (
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3" key={index}
              style={{ cursor: "pointer" }}
              onClick={() => handleArchiveURL(per.value, "Human Chat")}>
              <div className="card">
                <div className="text-center card-body">
                  <i className={getLabelIcon(per.type)}></i>
                  <p className="card-text font-weight-semibold mb-0">
                    <IntlMessages id={getLabel(per.type)} />
                  </p>
                  <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                    {/* {per.value + " Conversations (" + per.percentage + "%)"} */}
                    {per.value} <IntlMessages id="menu.conversations" /> ({per.percentage}%)
                  </p>
                </div>
              </div>
            </div>
          )}
          {per.type === "websiteRedirects" && (
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3" key={index}>
              <div className="card">
                <div className="text-center card-body">
                  <i className='color-theme-1'>
                    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                      width="40" height="40" viewBox="0 0 512.000000 512.000000"
                      preserveAspectRatio="xMidYMid meet">
                      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                        <path fill='currentColor' d="M3295 4946 c-94 -41 -124 -168 -58 -247 51 -60 41 -59 635 -59 l543 0 -1162 -1162 c-1264 -1265 -1186 -1180 -1168 -1275 9 -49 69 -109 118 -118 95 -18 10 -96 1274 1168 l1163 1161 2 -556 c3 -544 3 -557 24 -584 39 -53 71 -69 134 -69 63 0 95 16 134 69 21 27 21 35 21 806 0 771 0 779 -21 806 -11 15 -33 37 -48 48 -27 21 -37 21 -794 23 -622 2 -773 0 -797 -11z" />
                        <path fill='currentColor' d="M521 4304 c-169 -45 -301 -180 -346 -351 -23 -86 -23 -3340 0 -3426 45 -173 178 -307 350 -352 52 -13 260 -15 1715 -15 1805 0 1705 -3 1822 56 116 59 221 197 247 326 8 37 11 364 9 1065 -3 1004 -3 1012 -24 1039 -39 53 -71 69 -134 69 -63 0 -95 -16 -134 -69 -21 -27 -21 -37 -26 -1046 -5 -1009 -5 -1019 -26 -1046 -11 -15 -33 -37 -48 -48 l-27 -21 -1659 0 -1659 0 -27 21 c-15 11 -37 33 -48 48 l-21 27 0 1659 0 1659 21 27 c11 15 33 37 48 48 27 21 37 21 1046 26 1009 5 1019 5 1046 26 53 39 69 71 69 134 0 63 -16 95 -69 134 -27 21 -34 21 -1049 23 -868 2 -1030 0 -1076 -13z" />
                      </g>
                    </svg></i>
                  <p className="card-text font-weight-semibold mb-0">
                    <IntlMessages id={getLabel(per.type)} /></p>
                  <p className="lead text-center" style={{ fontSize: "1.2rem" }}>{per.value} <IntlMessages id="dashboards.clicks" /></p>
                </div>
              </div>
            </div>
          )}
        </Fragment>
      )}
      <div className='mb-4 col-sm-4 col-lg-3 col-xl-3'>
        <div className='card'>
          <div className='text-center card-body'>
            <i className='iconsminds-user' style={{ lineHeight: "51px" }}></i>
            <p className="card-text font-weight-semibold mb-0 mt-1">New Contacts</p>
            <p className="lead text-center mb-1" style={{ fontSize: "1.2rem", lineHeight: "1px" }}>
              {contactStatsData?.filter(x => x.name !== "" || x.email !== "" || x.phone !== "").length}<br />
            </p>
            <p className="lead text-center mb-1" style={{ fontSize: "14px" }}>
              ({contactStatsData?.filter(k => k.consent === "Yes").length} consented to remarketing)
            </p>
          </div>
        </div>
      </div>
      {data.filter(l => l.type === "estimatedTimeSaving").length > 0 &&
        <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
          <div className="card">
            <div className="text-center card-body">
              <i className={getLabelIcon(data.filter(l => l.type === "estimatedTimeSaving")[0].type)}></i>
              <p className="card-text font-weight-semibold mb-0">
                <IntlMessages id={getLabel(data.filter(l => l.type === "estimatedTimeSaving")[0].type)} />
              </p>
              {/* <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                {data.filter(l => l.type === "estimatedTimeSaving")[0].value > 180 ? CalculateHours(parseInt(data.filter(l => l.type === "estimatedTimeSaving")[0].value)) + " Hours" :
                  data.filter(l => l.type === "estimatedTimeSaving")[0].value + " Minutes"}
                {estimatedTimeSaving}
              </p> */}
              <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                {(() => {
                  const filtered = data.filter(l => l.type === "estimatedTimeSaving");
                  if (!filtered.length) return null;

                  const estTime = parseInt(filtered[0].value);
                  return estTime > 180 ? (
                    <>
                      {CalculateHours(estTime)} <IntlMessages id='dashboards.hours' />
                    </>
                  ) : (
                    <>
                      {estTime} <IntlMessages id="dashboards.minutes" />
                    </>
                  );
                })()}
                {estimatedTimeSaving}
              </p>

            </div>

          </div>
        </div>
      }

      {!isBusinessOperator && !isUtilityProvider && data.filter(l => l.type === "bookingEnquiries").length > 0 &&
        <div className="mb-4 col-sm-4 col-lg-3 col-xl-3"
          style={{ cursor: "pointer" }}
          onClick={() => handleArchiveURL(data.filter(l => l.type === "bookingEnquiries")[0].value, "Human Chat")}>
          <div className="card">
            <div className="text-center card-body">
              <i className={getLabelIcon(data.filter(l => l.type === "bookingEnquiries")[0].type)}></i>
              <p className="card-text font-weight-semibold mb-0">
                <IntlMessages id={getLabel(data.filter(l => l.type === "bookingEnquiries")[0].type)} />
              </p>
              <p className="lead text-center" style={{ fontSize: "1.2rem" }}>
                {data.filter(l => l.type === "bookingEnquiries")[0].value} <IntlMessages id="menu.conversations" /> ({data.filter(l => l.type === "bookingEnquiries")[0].percentage}%)
              </p>
            </div>
          </div>
        </div>
      }
      {!isBusinessOperator && !isUtilityProvider &&
        <Fragment>
          <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
            <div className="card">
              <div className="text-center card-body">
                <i className="svg-class"><svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                  width="30.000000pt" height="30.000000pt" viewBox="0 0 300.000000 300.000000"
                  preserveAspectRatio="xMidYMid meet">
                  <g transform="translate(0.000000,300.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                    <path d="M1265 2850 c-431 -89 -789 -405 -923 -817 -42 -128 -56 -222 -55 -378 0 -164 14 -247 63 -397 45 -134 127 -283 198 -361 l26 -27 -170 0 c-189 0 -214 -7 -254 -72 -19 -31 -20 -47 -18 -310 l3 -278 38 -37 37 -38 1278 -3 c1260 -2 1277 -2 1310 18 18 11 41 34 52 52 19 31 20 51 20 298 0 247 -1 267 -20 298 -40 65 -65 72 -254 72 l-170 0 26 28 c79 85 170 259 213 406 38 132 49 216 49 366 -1 244 -64 452 -199 656 -184 276 -476 468 -804 529 -115 21 -330 19 -446 -5z m21 -55 c-22 -16 -46 -20 -46 -7 0 15 13 22 39 22 25 -1 25 -1 7 -15z m184 -280 l0 -295 -260 0 c-143 0 -260 2 -260 4 0 16 60 157 97 229 94 181 216 301 348 343 81 26 75 50 75 -281z m179 264 c111 -49 222 -168 304 -326 37 -72 97 -213 97 -229 0 -2 -117 -4 -260 -4 l-260 0 0 296 0 296 38 -7 c20 -3 57 -15 81 -26z m106 20 c13 -19 -5 -23 -38 -6 l-32 16 32 0 c17 1 35 -4 38 -10z m-550 -41 c-49 -36 -103 -98 -162 -186 -55 -82 -137 -258 -149 -319 l-6 -33 -199 0 -199 0 17 28 c81 129 226 283 339 359 75 51 187 108 284 144 91 34 116 36 75 7z m657 -4 c94 -34 215 -94 291 -146 112 -76 257 -228 331 -345 l26 -43 -199 0 -199 0 -6 33 c-12 61 -94 236 -149 319 -59 88 -113 150 -162 186 -40 28 -21 27 67 -4z m-350 -576 c-9 -9 -15 -9 -24 0 -10 10 -10 15 2 22 9 6 19 5 24 0 7 -7 6 -14 -2 -22z m-646 -35 c-23 -59 -56 -284 -56 -385 l0 -68 -235 0 -234 0 5 53 c13 129 59 308 101 390 l14 27 205 0 c188 0 206 -1 200 -17z m604 -218 l0 -235 -301 0 -302 0 7 103 c7 112 19 196 42 300 l16 67 269 0 269 0 0 -235z m614 163 c27 -125 35 -185 42 -293 l7 -105 -302 0 -301 0 0 235 0 235 269 0 270 0 15 -72z m469 45 c43 -84 91 -271 100 -390 l4 -53 -232 0 -232 0 -6 113 c-6 103 -36 299 -52 340 -7 16 7 17 199 17 l205 0 14 -27z m-1743 -570 c0 -96 31 -311 55 -393 4 -13 -22 -15 -203 -13 l-207 3 -26 62 c-33 82 -66 207 -74 283 -3 33 -8 75 -11 93 l-5 32 236 0 235 0 0 -67z m660 -170 l0 -238 -270 0 -270 0 -14 65 c-20 88 -46 288 -46 356 l0 54 300 0 300 0 0 -237z m660 183 c0 -68 -26 -268 -46 -356 l-14 -65 -270 0 -270 0 0 238 0 237 300 0 300 0 0 -54z m523 -3 c-9 -102 -40 -235 -74 -326 l-34 -88 -207 -2 c-181 -2 -207 0 -203 13 24 82 55 297 55 393 l0 67 234 0 235 0 -6 -57z m-1747 -545 c12 -35 31 -83 43 -107 11 -25 21 -46 21 -48 0 -2 -71 -3 -158 -3 l-158 0 -26 28 c-30 31 -138 181 -138 191 0 3 89 5 197 4 l198 -3 21 -62z m564 -46 l0 -112 -217 2 -218 3 -37 87 c-21 48 -40 98 -43 110 l-6 23 261 0 260 0 0 -113z m580 108 c0 -10 -59 -159 -75 -190 l-16 -30 -214 0 -215 0 0 113 0 112 260 0 c143 0 260 -2 260 -5z m460 -1 c0 -10 -108 -160 -138 -191 l-26 -28 -158 0 c-87 0 -158 2 -158 5 0 3 11 27 24 53 13 26 31 72 41 102 10 30 19 57 20 60 4 7 395 6 395 -1z m274 -305 l26 -27 0 -257 0 -257 -26 -27 -27 -26 -1257 0 -1257 0 -27 26 -26 27 0 257 0 257 26 27 27 26 1257 0 1257 0 27 -26z" />
                    <path d="M460 703 c-48 -25 -76 -81 -61 -126 14 -41 107 -133 143 -142 17 -4 28 -16 33 -32 9 -36 101 -130 140 -143 84 -28 166 61 132 142 -17 40 -106 125 -139 133 -16 4 -29 18 -36 39 -14 37 -112 136 -136 136 -8 0 -20 2 -28 5 -7 3 -29 -3 -48 -12z m115 -103 c27 -27 45 -53 41 -57 -4 -5 -16 2 -27 15 -10 13 -26 22 -36 20 -26 -5 -28 -44 -4 -60 22 -14 28 -28 11 -28 -6 0 -31 21 -55 48 -45 47 -55 78 -33 100 23 23 54 12 103 -38z m89 -92 c15 -25 -32 -73 -63 -63 -27 8 -27 25 0 59 23 29 46 31 63 4z m78 -75 c26 -26 48 -55 48 -64 0 -64 -47 -66 -112 -4 -27 24 -48 49 -48 55 0 17 14 11 28 -11 17 -27 56 -22 60 8 2 14 -4 26 -17 33 -20 10 -29 30 -14 30 4 0 29 -21 55 -47z" />
                    <path d="M1101 613 c-12 -9 -14 -16 -5 -30 11 -17 48 -18 700 -21 379 -1 699 0 712 3 22 5 31 38 13 50 -6 3 -323 6 -707 8 -527 1 -701 -1 -713 -10z" />
                    <path d="M1102 428 c-14 -14 -16 -35 -3 -43 7 -4 783 -8 949 -5 9 0 12 10 10 28 l-3 27 -470 3 c-358 2 -474 -1 -483 -10z" />
                  </g>
                </svg></i>
                <p className="card-text font-weight-semibold mb-0">
                  <IntlMessages id={getLabel('bookingengine')} /></p>
                <p className="lead text-center" style={{ fontSize: "1.2rem" }}>{bookingEngineSearchData.bookingEngineLeads} <IntlMessages id="dashboards.leads" /></p>
              </div>
            </div>
          </div>
          {renderBookingEngine()}
        </Fragment>
      }
    </Fragment>)
  }
  return (
    <Fragment>
      {/* <div className="iconcards-row row d-flex">
        {numbertimedata && (
          NumberTimeDiv(numbertimedata)
        )}
      </div> */}
      <div className="iconcards-row row d-flex">
        {numberdata && (
          <Fragment>
            {NewDisplayIntegrationConversations(numberdata)}
          </Fragment>
        )}
        {/* {totalTicketStats && (
          getTotalTicket(totalTicketStats)
        )} */}
      </div>
    </Fragment>
  );
};

export default Number;
